var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.b(),_vm.className],style:(_vm.styleSizeName)},[_c('div',{ref:_vm.id,style:(_vm.styleChartName)})])
}
var staticRenderFns = []

export { render, staticRenderFns }